import objectAssign from 'object-assign';
import initialState from './initialState';


export default function reducer(state=initialState.data, action){
  let newState;
  newState = objectAssign({}, state);
  switch (action.type){
    case 'INIT_DATA': {
      return objectAssign({}, action.payload);
    }
  }
  return newState;
}


// WEBPACK FOOTER //
// ./src/reducers/dataReducer.js